import { lazy } from 'react';

export default lazy(() =>
  import(/* webpackChunkName: 'checkout_success_page' */ './CheckoutSuccess'),
);
